export const SPAN_KPI = 'col-span-12 sm:col-span-6 lg:col-span-3';
export const SPAN_FULL = 'col-span-12';
export const SPAN_HALF = 'col-span-12 lg:col-span-6';
export const SPAN_CHART = SPAN_FULL;
export const SPAN_ATTENTION = SPAN_HALF;
export const SPAN_LEADS = SPAN_HALF;
